/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { trackFetchErrors } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { ProjectShortcut } from '../../types.tsx';

export const fetchShortcuts = (projectKeyOrId: string): Promise<ProjectShortcut[]> => {
	try {
		return fetchJson(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'fetchProjectShortcuts',
			packageName: 'jiraNavigationAppsResources',
		});
		throw error;
	}
};
